import ScreenContainer from '../display/ui/ScreenContainer';

export default class Transition extends ScreenContainer {
  constructor(game) {
    super(game);

    this.onFadeEnd = new Phaser.Signal();

    this.fade = this.game.add.spine(
      this.game.defaultWidth / 2,
      this.game.defaultHeight / 2,
      'transition_ring',
      true
    );
    this.fade.anchor.set(0.5, 1);
    this.add(this.fade);
    this.fade.visible = false;
  }

  fadeIn() {
    this.game.add.existing(this);
    this.game.world.bringToTop(this);

    this.fade.visible = true;
    this.fade.setAnimationByName(0, 'fade_in', false);
    this.update();
    this.fade.onComplete.addOnce(this.handleFadeInEnd, this);
  }

  fadeOut() {
    this.game.add.existing(this);
    this.game.world.bringToTop(this);

    this.fade.visible = true;
    this.fade.setAnimationByName(0, 'fade_out', false);
    this.update();
    this.updateTransform();
    this.fade.onComplete.addOnce(this.handleFadeOutEnd, this);
  }

  handleFadeInEnd() {
    this.onFadeEnd.dispatch();
  }

  handleFadeOutEnd() {
    this.fade.visible = false;
    this.onFadeEnd.dispatch();
  }

  destroy() {
    this.fade.destroy();
    this.fade = null;

    super.destroy();
  }
}
